import React, { ReactNode } from "react";

import { Translate } from "@/app/application/Translate";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";

type Props = {
	legend: string;
	children: ReactNode;
	placeholder?: string;
	translationString?: string;
};

const StyledBox = styled(Box)({
	width: "90%",
	display: "flex",
	flexDirection: "column",
	gap: "10px",
});

const CustomFieldset = ({ legend, children, translationString }: Props) => {
	return (
		<Box
			component="fieldset"
			className="input-container"
			sx={{
				display: "flex",
				width: "100%",
				alignItems: "flex-start",
				mt: 2,
				pt: 1.5,
				px: 1.5,
				border: "1px solid",
				borderColor: "divider",
				borderRadius: 2,
			}}
		>
			<Typography
				component="legend"
				variant="body2"
				sx={{ color: "text.secondary", fontWeight: 600, mb: 0.5, px: 0.5 }}
			>
				<Translate String={translationString ?? ""}>{legend}</Translate>
			</Typography>
			<StyledBox>{children}</StyledBox>
		</Box>
	);
};

export default CustomFieldset;
